/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultReviewCard from "parts/Cards/ReviewCards/DefaultReviewCard";

// Images
import appleLogo from "assets/images/logos/gray-logos/logo-apple.svg";
import facebookLogo from "assets/images/logos/gray-logos/logo-facebook.svg";
import nasaLogo from "assets/images/logos/gray-logos/logo-pinterest.svg";
import vodafoneLogo from "assets/images/logos/gray-logos/logo-spotify.svg";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Trusted by </MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            300+ clients
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
          Our solutions have been rigorously tested and trusted by over 10 clients across various industries. Their feedback and real-world usage help us continuously refine and improve our offerings, ensuring that we meet the highest standards of quality, security, and performance. When you choose us, you’re benefiting from proven solutions that have been tested and validated in diverse environments..
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Nits"
              date="6 Months ago"
              review="Working with this team has been an absolute game-changer for us. Their expertise in development and cybersecurity has given us the confidence to expand without worrying about security risks. The solutions they provided were tailor-made to fit our needs and have improved both our efficiency and data protection. Highly recommend!."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="info"
              name="Natile"
              date="4 years ago"
              review="The partnership with this company has been seamless from start to finish. They not only provided robust cybersecurity solutions but also took the time to understand our business objectives. The development tools and platforms they delivered have significantly optimized our workflow, and we’ve seen a real impact on both security and performance."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Sarbie"
              date="3 weeks ago"
              review="We were impressed with how quickly and effectively they identified our cybersecurity gaps and implemented solutions that gave us peace of mind. Their development approach is not only innovative but also incredibly user-centric. It’s rare to find a team that combines technical expertise with such a personal touch."
              rating={5}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
        <Grid container spacing={3} justifyContent="center">
          
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={facebookLogo} alt="Facebook" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={nasaLogo} alt="Nasa" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={vodafoneLogo} alt="Nasa" width="100%" opacity={0.6} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
